/** Dùng trong Vuex khi response từ service là `unknown` (unwrap). */
export function apiBody(res) {
    return res;
}
